import APIClient from '../../../common/APIClient';
import { displayError } from '../commonActions';
import moment from 'moment';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}


export const createUserCostCenter = (id, user_cost_center, effectivity_date) => {
  return (dispatch) => {

    //if user_cost_center still an object means it was never updated
    if (typeof(user_cost_center) === 'object') {
      return; 
    }

    client().post(
      'user-cost-center/create', {
        user_id: id, 
        cost_center_id: user_cost_center, 
        effectivity_date: effectivity_date
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        console.log('New cost center for the user has been created.');
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const updateUserCostCenter = (id, user_cost_center, effectivity_date) => {
  return (dispatch) => {

    client().post(
      'user-cost-center/update', {
        user_id: id, 
        cost_center_id: user_cost_center, 
        effectivity_date: effectivity_date
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        console.log('Cost center for the user has been updated.');
      }
    }).catch(error => {
      console.log()
      dispatch(displayError(error));
    })
  }
}

export const getCurrentCostCenter = (userCostCenters, currDate) => {

  if (typeof(userCostCenters) === "undefined") {
    return null;
  }

  if (!userCostCenters.length) {
    return null;
  }

  let arrCostCenters = [];

  userCostCenters.length && userCostCenters.filter(data => {
    if (moment(data.effectivity_date) <= moment(currDate)) {
      return data;
    }
    return false;
  }).forEach(userCostCenter => {
    if (userCostCenter) {
      arrCostCenters.push(userCostCenter);
    }
  })

  return arrCostCenters.length ? arrCostCenters[0] : null;
}

